import { doInteraction } from './Analytics';
export function selectYear({ Years }) {
    doInteraction(`DPH CDI|YEAR, ${Years.replace('ALLYEARS', 'allYrs')}`);
}
export function selectViewBy({ ViewBy }) {
    doInteraction(`DPH CDI|VIEWBY, ${ViewBy}`);
}
export function selectDataType({ DataValueTypeId }) {    
    doInteraction(`DPH CDI|DATATYPE, ${DataValueTypeId}`);
}